module.exports = __webpack_public_path__ + "img/product2.1118ab03.png";